// src/components/Safety/SafetyInlineWarning.tsx
// Subtle dismissible banner shown in the editor after a save detects
// layer 1 or 2 issues. Non-blocking — story still saves, just warns.
import React from 'react';
import { SafetyIssue } from '../../hooks/useSafetyCheck';
 
const C = {
  tertiary:          '#6f5900',
  tertiaryContainer: '#fed01b',
  onSurface:         '#252f3c',
  onSurfaceVariant:  '#525c6a',
};
 
interface Props {
  issues: SafetyIssue[];
  onDismiss: () => void;
}
 
const SafetyInlineWarning: React.FC<Props> = ({ issues, onDismiss }) => {
  if (issues.length === 0) return null;
 
  return (
    <div style={{
      margin: '0 24px 0',
      background: `${C.tertiaryContainer}90`,
      border: `2px solid ${C.tertiary}40`,
      borderRadius: '12px',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      animation: 'warnSlideIn .2s ease-out',
    }}>
      <span style={{ fontSize: '1.2rem', flexShrink: 0, marginTop: '1px' }}>⚠️</span>
      <div style={{ flex: 1 }}>
        <div style={{
          fontFamily: "'Epilogue', sans-serif", fontWeight: '800',
          fontSize: '0.85rem', color: C.tertiary, marginBottom: '4px',
        }}>
          Fix before publishing
        </div>
        <ul style={{ margin: 0, paddingLeft: '16px', fontSize: '0.82rem', color: C.onSurface }}>
          {issues.map((issue, i) => (
            <li key={i} style={{ lineHeight: '1.6' }}>{issue.detail}</li>
          ))}
        </ul>
      </div>
      <button
        onClick={onDismiss}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          fontSize: '1.1rem', color: C.onSurfaceVariant,
          flexShrink: 0, lineHeight: 1, padding: '2px',
        }}
        title="Dismiss"
      >
        ×
      </button>
      <style>{`
        @keyframes warnSlideIn {
          from { opacity: 0; transform: translateY(-6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};
 
export default SafetyInlineWarning;